import React from 'react';
import { CLIENT_LOGOS } from '@/lib/content';

export default function ClientMarquee() {
    const logos = [...CLIENT_LOGOS, ...CLIENT_LOGOS];
    return (
        <section className="relative bg-brand-orange overflow-hidden">
            <div className="ticker-mask">
                <div className="flex gap-16 py-7 animate-marquee whitespace-nowrap">
                    {logos.map((l, i) => (
                        <span
                            key={`${l}-${i}`}
                            className="font-display font-extrabold text-white/95 text-2xl md:text-3xl tracking-[0.18em] flex items-center gap-6"
                        >
                            {l}
                            <span className="text-white/50 text-lg">✦</span>
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
